import React from "react";

// { events, loading, newCount, markSeen } - a single app-wide poll of
// the upcoming events list, shared by the Upcoming page (so it isn't
// fetching its own separate copy) and Navigationbar (so the "new
// event" badge on the Upcoming tab stays accurate no matter which
// page the user is actually on).
const UpcomingEventsContext = React.createContext();

export { UpcomingEventsContext };
